define('components/elements/link',['require','react','plugins/open-new-tab','et_flux'],function(require) {
  var React, a, createComponent, open_new_tab, span, _ref;
  React = require("react");
  open_new_tab = require("plugins/open-new-tab");
  createComponent = require("et_flux").createComponent;
  _ref = React.DOM, a = _ref.a, span = _ref.span;
  return createComponent("Link", {
    propTypes: {
      className: React.PropTypes.string,
      href: React.PropTypes.string,
      tip_title: React.PropTypes.string,
      open_new_tab: React.PropTypes.bool
    },
    componentDidMount: function() {
      var _ref1;
      return (_ref1 = $(".tip")) != null ? _ref1.tooltip() : void 0;
    },
    handleClick: function(e) {
      e.preventDefault();
      if (_.isFunction(this.props.onClick)) {
        return this.props.onClick();
      }
    },
    render: function() {
      var link_classes;
      link_classes = EverTrue.classSet(this.props.className, "link", {
        "tip": !!this.props.tip_title
      });
      if (this.props.href) {
        return a({
          title: this.props.tip_title,
          href: this.props.href,
          rel: this.props.open_new_tab === true ? "external" : "",
          className: link_classes,
          onClick: this.handleClick
        }, this.props.children);
      } else {
        return span({
          title: this.props.tip_title,
          className: link_classes,
          onClick: this.handleClick
        }, this.props.children);
      }
    }
  });
});

//# sourceMappingURL=link.js.map
;
